function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M7.628 7l5.997 5.997-.63.63-5.996-5.992-5.993 5.992-.63-.63 5.996-5.998L.375 1.003l.63-.63 5.997 5.992L12.994.373l.63.63-5.996 5.998V7z",
  id: "icon-x_svg__a",
  stroke: "none",
  fillRule: "evenodd"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#icon-x_svg__a"
});

var SvgIconX = function SvgIconX(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-x.d56e40b5.svg";
export { SvgIconX as ReactComponent };